// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2tui7","inner":"Form_inner__3k8A9","range":"Form_range__1I679","name":"Form_name__1r4dG","actions":"Form_actions__2gq-D"};